import styled from 'styled-components';

import { colors, medias } from 'assets/styled/tokens';

export const Sidebar = styled.div`
  left: ${props => (props.isOpen ? `0px` : `-100%`)};
  width: 88px;
  height: 100%;
  background-color: ${colors.white};
  box-shadow: rgba(0, 0, 0, 0.15) 0px 1px 8px 0px;
  display: flex;
  flex-direction: column;

  justify-content: space-between;
  z-index: 99;
  position: fixed;
  transition: all 0.3s ease-in-out;

  ::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: ${medias.desktopSm}) {
    display: flex;
    left: 0;
  }
`;

export const SidebarContainer = styled.div`
  height: 100%;
  padding: 16px 7px;
  background-color: white;
  @media screen and (min-width: ${medias.desktopXl}) {
    padding: 24px 7px;
  }
`;

export const Logo = styled.div`
  border: 1px solid #e5e5e5;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto 8px;

  img {
    display: inline-block;
    transition: opacity 1s ease-in-out;
    &::webkit-transition {
      opacity: 1s ease-in-out;
    }
  }
  svg {
    cursor: pointer;
  }

  @media screen and (max-width: ${medias.desktopSm}) {
    width: 48px;
    height: 48px;
    img {
      height: 48px;
    }
  }
  @media screen and (max-width: ${medias.desktopXl}) {
    width: 56px;
    height: 56px;
    img {
      height: 56px;
    }
  }
`;

export const MenuItems = styled.nav`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;

  margin-top: 4px;
  width: 100%;
  @media screen and (min-width: ${medias.desktopXl}) {
    margin-top: 12px;
  }
`;
export const StyledMenuCategory = styled.ul`
  height: 100%;
  //overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
  align-items: center;

  & + ul {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid ${colors.whiteGray};
  }
`;
